module.exports = __webpack_public_path__ + "static/img/Rooster.54fd1fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Rooster.svg
// module id = 1367
// module chunks = 0